import * as React from 'react'
import { observer, inject } from 'mobx-react'
import styled from 'styled-components'
import Checkmark from 'src/components/atoms/input/Checkmark'
import { SmallHintText } from 'src/components/atoms/configurator'
import { StoreProps } from 'src/stores'
import CustomModal from 'src/components/containers/CustomModal'

const NumberFormat = require('react-number-format')

const pig = require('src/assets/configurator/financing.png')
// const euroIcon = require('src/assets/configurator/euro_icon.png')
const klarnaIcon = require('src/assets/configurator/klarna_icon.png')
const chashpressoLogo = require('src/assets/configurator/cashpresso.png')

interface FinancingState {
  modalOpen: boolean
}

@inject('confStore')
@observer
export class Financing extends React.Component<StoreProps, FinancingState> {
  constructor(props) {
    super(props)
    this.state = { modalOpen: false }
  }

  onCheck = () => {
    const { confStore } = this.props
    confStore.setInterestedInFinancing(
      !confStore.getOffer.interestedInFinancing
    )
  }

  render() {
    const { confStore } = this.props
    const { modalOpen } = this.state

    return (
      <>
        <MoreInfo
          open={modalOpen}
          onClose={() => this.setState({ modalOpen: false })}
        />
        <FinancingContainer>
          <img src={klarnaIcon} alt='euro' />
          <SmallHintText>
            Ich habe Interesse an einer <strong>flexiblen Ratenzahlung</strong>{' '}
            der Bestattungs&shy;kosten über Klarna.
            {/* <u onClick={() => this.setState({ modalOpen: true })}> Mehr Info</u> */}
          </SmallHintText>
          <FinancingCheckmark
            checked={confStore.getOffer.interestedInFinancing}
            onClick={this.onCheck}
          />
        </FinancingContainer>
      </>
    )
  }
}

@inject('confStore')
@observer
export class FinancingProvision extends React.Component<StoreProps> {
  render() {
    const { confStore } = this.props
    const installments =
      Math.ceil((confStore.offerGrandTotal() / 60) * 100) / 100
    return (
      <FinancingContainer>
        <img src={pig} alt='euro' />
        <SmallHintText>
          <strong>Finanzielle Absicherung</strong>
          <br />
          Sichere Vorsorge über das Benu Treuhandkonto. Bezahlung einmalig oder
          flexibel z.B. über <u>60 Monate</u> mit{' '}
          <u>
            <NumberFormat
              value={installments}
              displayType='text'
              thousandSeparator='.'
              decimalSeparator=','
              prefix='€&nbsp;'
              suffix=' '
              decimalScale={2}
              fixedDecimalScale={!Number.isInteger(installments)}
            />
            monatlich
          </u>
          .
        </SmallHintText>
      </FinancingContainer>
    )
  }
}

const FinancingContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 7.5px;
  background: #fae6c1;

  & > * {
    margin: 0 7.5px;
  }

  img {
    width: 25%;
    max-width: 64px;
  }

  p {
    width: auto;
    u {
      cursor: pointer;
    }
  }
`

const FinancingCheckmark = styled(Checkmark)`
  position: static;
  flex-grow: 0;
  flex-shrink: 0;
`

interface MoreInfoProps {
  open: boolean
  onClose: () => void
}

const MoreInfo = (props: MoreInfoProps) => {
  const { open, onClose } = props

  return (
    <CustomModal
      cancelX
      open={open}
      onClose={onClose}
      closeButtonText='Zurück'
      title='Finanzierungsmöglichkeit'>
      <p style={{ textAlign: 'left' }}>
        Aus Erfahrung wissen wir, dass die Organisation einer Bestattung eine
        unerwartete finanzielle Belastung darstellen kann.
      </p>
      <p style={{ textAlign: 'left' }}>
        Genau aus diesem Grund arbeiten wir mit dem österreichischen
        Kreditanbieter CASHPRESSO zusammen, um einfach und unkompliziert einen
        Bestattungskredit in nur 10 Minuten zu beantragen.
      </p>
      <img src={chashpressoLogo} alt='cashpresso_logo' width='50%' />
      <p style={{ textAlign: 'left' }}>Hier die Eckpunkte zur Finanzierung:</p>
      <div className='product-long-desc' style={{ textAlign: 'left' }}>
        <ul>
          <li>
            Bis zu € 1.500 der Bestattungskosten finanzieren (die verbleibende
            Summe kann auf Rechnung oder per Vorkasse bezahlt werden)
          </li>
          <li>60 Tage zinsfrei</li>
          <li>Flexibel anpassbare Ratenzahlung</li>
          <li>Effektiver Zinssatz von 14,99% pro Jahr</li>
        </ul>
      </div>
      <p style={{ textAlign: 'left' }}>
        Wir beraten Sie jederzeit gerne zur Bestattungs&shy;finanzierung und
        leiten alle wichtigen Schritte für Sie in die Wege. Außerdem können Sie
        sich auf{' '}
        <a href='https://cashpresso.com' target='_blank'>
          cashpresso.com
        </a>{' '}
        detailliert zur Finanzierung informieren.
      </p>
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/configurator/Financing.tsx